/**
 * Verkline Wishlist - localStorage based
 */

const WISHLIST_KEY = 'verkline_wishlist';

// Get wishlist from localStorage
function getWishlist() {
  try {
    const data = localStorage.getItem(WISHLIST_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
}

// Save wishlist to localStorage
function saveWishlist(wishlist) {
  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  } catch (e) {
    console.error('Error saving wishlist:', e);
  }
}

// Check if product is in wishlist
function isInWishlist(productId) {
  const wishlist = getWishlist();
  return wishlist.some(item => item.id === productId);
}

// Add product to wishlist
function addToWishlist(product) {
  const wishlist = getWishlist();
  if (!wishlist.some(item => item.id === product.id)) {
    wishlist.push(product);
    saveWishlist(wishlist);
    updateWishlistCount();
    return true;
  }
  return false;
}

// Remove product from wishlist
function removeFromWishlist(productId) {
  let wishlist = getWishlist();
  wishlist = wishlist.filter(item => item.id !== productId);
  saveWishlist(wishlist);
  updateWishlistCount();
}

// Toggle product in wishlist
function toggleWishlist(button) {
  const productId = button.dataset.productId;
  const product = {
    id: productId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    price: button.dataset.productPrice,
    image: button.dataset.productImage
  };

  if (isInWishlist(productId)) {
    removeFromWishlist(productId);
    button.classList.remove('active');
    showWishlistNotification('Usunięto z ulubionych');
  } else {
    addToWishlist(product);
    button.classList.add('active');
    showWishlistNotification('Dodano do ulubionych');
  }
}

// Update wishlist count in header
function updateWishlistCount() {
  const wishlist = getWishlist();
  const countEl = document.getElementById('wishlist-count');
  if (countEl) {
    if (wishlist.length > 0) {
      countEl.textContent = wishlist.length;
      countEl.style.display = 'flex';
    } else {
      countEl.style.display = 'none';
    }
  }
}

// Show notification
function showWishlistNotification(message) {
  // Remove existing notification
  const existing = document.querySelector('.wishlist-notification');
  if (existing) existing.remove();

  const notification = document.createElement('div');
  notification.className = 'wishlist-notification';
  notification.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#FDCF0B" stroke="#FDCF0B" stroke-width="2">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
    <span>${message}</span>
  `;
  document.body.appendChild(notification);

  // Animate in
  setTimeout(() => notification.classList.add('show'), 10);

  // Remove after 2 seconds
  setTimeout(() => {
    notification.classList.remove('show');
    setTimeout(() => notification.remove(), 300);
  }, 2000);
}

// Initialize wishlist buttons state
function initWishlistButtons() {
  const buttons = document.querySelectorAll('.verkline-product-card__wishlist-btn');
  buttons.forEach(button => {
    const productId = button.dataset.productId;
    if (isInWishlist(productId)) {
      button.classList.add('active');
    }
  });
}

// Render wishlist on wishlist page
function renderWishlistPage() {
  const container = document.getElementById('wishlist-products');
  if (!container) return;

  const wishlist = getWishlist();
  const emptyMessage = document.getElementById('wishlist-empty');

  if (wishlist.length === 0) {
    container.style.display = 'none';
    if (emptyMessage) emptyMessage.style.display = 'block';
    return;
  }

  if (emptyMessage) emptyMessage.style.display = 'none';
  container.style.display = 'grid';

  container.innerHTML = wishlist.map(item => `
    <div class="wishlist-product" data-product-id="${item.id}">
      <a href="/products/${item.handle}" class="wishlist-product__image">
        <img src="${item.image}" alt="${item.title}" loading="lazy">
      </a>
      <div class="wishlist-product__info">
        <a href="/products/${item.handle}" class="wishlist-product__title">${item.title}</a>
        <div class="wishlist-product__price">${item.price}</div>
      </div>
      <button type="button" class="wishlist-product__remove" onclick="removeFromWishlistPage('${item.id}')">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
  `).join('');
}

// Remove from wishlist page
function removeFromWishlistPage(productId) {
  removeFromWishlist(productId);
  renderWishlistPage();
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  updateWishlistCount();
  initWishlistButtons();
  renderWishlistPage();
});

// Add notification styles dynamically
const wishlistStyles = document.createElement('style');
wishlistStyles.textContent = `
  .wishlist-notification {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%) translateY(100px);
    background: #1a1a1a;
    color: #fff;
    padding: 12px 20px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 500;
    z-index: 10000;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
  }
  .wishlist-notification.show {
    transform: translateX(-50%) translateY(0);
  }
`;
document.head.appendChild(wishlistStyles);
